const maskString = (str: string, pattern: string) => {
  let i = 0;
  const padded = pattern.replace(/#/g, () => {
    const newStr = str[i];
    i += 1;
    return newStr;
  });
  return padded;
};

export { maskString };
